import React, { Component } from 'react';

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';
// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

import config from '@config';
import Program from './program';

class TextView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      request: false,
    };
  }

  componentDidMount() {
    window.dispatchEvent(new Event(config.events.renderedGrid));
    if (!this.props.selectedChannel) {
      this.props.setSelectedChannel(this.props.channels[0]['service_id']);
    }
  }

  componentDidUpdate(prevProps) {
    window.dispatchEvent(new Event(config.events.renderedGrid));
    const programsToRequest = [];
    this.props.programs.forEach(p => {
      if (!p.synopsis && !p.requesting) {
        programsToRequest.push({
          sid: this.props.selectedChannel.service_id,
          id: p.uuid,
          pid: p.program_id,
        });
      }
    });
    if (programsToRequest.length > 0) {
      this.props.getProgramsDetails(programsToRequest);
    }
  }

  updateSelectedChannel(service_id) {
    this.props.setSelectedChannel(service_id);
  }

  handleSlideChange(e) {
    const slide = this.props.channels[e.realIndex].service_id;
    this.updateSelectedChannel(slide);
  }

  render() {
    if (!this.props.selectedChannel) {
      return null;
    }

    return (
      <div className="tvg-text-view">
        <Swiper
          spaceBetween={50}
          slidesPerView={3}
          navigation
          centeredSlides={true}
          loop={true}
          // scrollbar={{ draggable: true }}
          slideToClickedSlide={true}
          onSlideChange={e => this.handleSlideChange(e)}
          breakpoints={{
            768: {
              slidesPerView: 5,
            },
          }}
        >
          {this.props.channels.map(c => (
            <SwiperSlide key={c.service_id}>
              {() => (
                <div
                  onClick={e => this.updateSelectedChannel(c.service_id)}
                  className={`tvg-text-view__channel-slide ${
                    this.props.selectedChannel.service_id === c.service_id
                      ? 'is-selected'
                      : ''
                  }`}
                >
                  {c.logical_channel_number}: {c.title}
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        {this.props.programs.length == 0 && <div className="fv-loading" />}
        <div className="tvg-text-view__programs-container container">
          <div className="tvg-text-view__programs">
            {this.props.programs.map((p, i) => (
              <Program
                key={`textview-${p.uuid}`}
                program={p}
                index={i}
                isActiveDayToday={this.props.isActiveDayToday}
                accessibility={this.props.accessibility}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default TextView;
